import { useSelector } from "react-redux";
import _uniq from "lodash/uniq";

import ShareInformationTopSection from "components/lib/Global/ShareInformationTopSection";
import NominalSharesTable from "components/PLCTABS/NominalShareCapitalTab/NominalSharesTable";
import SharesCategoryTabs from "components/PLCTABS/NominalShareCapitalTab/SharesCategoryTabs";
import { getTakenShares, roundNumber } from "utils";

export default function ShareInformation({ disabledRightsEditor }) {
  const {
    company: { nominalShares, individualOfficials, corporateOfficials },
  } = useSelector((state) => state.historyCompanyDashboardSlice);

  const companyOfficials = [
    ...(individualOfficials || []),
    ...(corporateOfficials || []),
  ];

  const takenShares = getTakenShares(companyOfficials);

  const sumNominalCapital = nominalShares
    .map((share) => share.sharesValue * share.sharesNumber)
    .reduce((a, b) => a + b, 0);

  const sumOfVotingRights = nominalShares.reduce(
    (acc, share) => roundNumber(acc + Number(share.votingRights)),
    0
  );

  return (
    <div className="mt-6">
      <ShareInformationTopSection
        sumNominalCapital={sumNominalCapital}
        sumOfVotingRights={sumOfVotingRights}
      />
      <NominalSharesTable
        nominalShares={nominalShares}
        takenShares={takenShares}
        handleEdit={() => null}
        handleView={() => null}
      />
      <div className="mt-12">
        <SharesCategoryTabs
          isInChangesModule={false}
          nominalShares={nominalShares}
          categories={_uniq(nominalShares.map((row) => row.sharesCategory))}
          disabledRightsEditor={disabledRightsEditor}
        />
      </div>
    </div>
  );
}
